import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface TimelineProps {
  isTerminated?: boolean
}

export const Timeline = observer(({ isTerminated = false }: TimelineProps) => {
  return (
    <Box width="s80" paddingTop={isTerminated ? 's32' : 's48'} paddingBottom="s8">
      <Box background="grey600" height="full" width="s2" alignSelf="end"></Box>
    </Box>
  )
})
